import { Box, Stack, Typography } from '@mui/material'
import type { ReactNode } from 'react'

type SectionHeaderProps = {
  title: string
  subtitle?: string
  right?: ReactNode
}

/** Card/section title with optional subtitle and right-aligned actions. */
export default function SectionHeader({ title, subtitle, right }: SectionHeaderProps) {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'flex-end',
        justifyContent: 'space-between',
        gap: 2,
      }}
    >
      <Stack spacing={0.25}>
        <Typography variant="h6" sx={{ fontSize: 18, lineHeight: 1.2 }}>
          {title}
        </Typography>
        {subtitle && (
          <Typography variant="body2" color="text.secondary" sx={{ fontSize: 13 }}>
            {subtitle}
          </Typography>
        )}
      </Stack>
      {right}
    </Box>
  )
}
